import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import { Subs } from "../../constants"
import { cancelSub, uncancelSub } from "../../api/subscribes"
import { message } from "antd"
import { updateAccount } from "../../api/users"

export default class SubscribeStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  subsList: any[] = Subs
  anim1: boolean = false
  anim2: boolean = false

  isSelectSubVisible: boolean = false
  isSubCancelVisible: boolean = false
  isSubUncancelVisible: boolean = false
  isBotSubCancelVisible: boolean = false
  isPaymentModalVisible: boolean = false
  isStandartLoading: boolean = false
  isVipLoading: boolean = false
  isNotifyLoading: boolean = false
  isSubVisible: boolean = true
  isDULoading: boolean = false
  isDataUnfilled: boolean = false
  isSubConfirmVisible: boolean = false

  selectedSub: any = Subs[0]
  selectedSubIx: number = -1

  userEmail: string = ""
  userName: string = ""

  activeTab: string = "sub2"
  subType: string = "sub2"

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  public setAnim1 = (val: boolean) => this.anim1 = val
  public setAnim2 = (val: boolean) => this.anim2 = val
  
  public setSubsList = (val: any[]) => this.subsList = val
  public setSelectedSub = (val: any) => this.selectedSub = val
  public setSelectedSubIx = (val: number) => this.selectedSubIx = val
  
  public setIsSelectSubVisible = (val: boolean) => this.isSelectSubVisible = val
  public setIsSubCancelVisible = (val: boolean) => this.isSubCancelVisible = val
  public setIsSubUncancelVisible = (val: boolean) => this.isSubUncancelVisible = val
  public setIsBotSubCancelVisible = (val: boolean) => this.isBotSubCancelVisible = val
  public setIsPaymentModalVisible = (val: boolean) => this.isPaymentModalVisible = val
  public setIsStandartLoading = (val: boolean) => this.isStandartLoading = val
  public setIsVipLoading = (val: boolean) => this.isVipLoading = val
  public setIsNotifyLoading = (val: boolean) => this.isNotifyLoading = val
  public setIsSubVisible = (val: boolean) => this.isSubVisible = val
  public setIsDULoading = (val: boolean) => this.isDULoading = val
  public setIsDataUnfilled = (val: boolean) => this.isDataUnfilled = val
  public setIsSubConfirmVisible = (val: boolean) => this.isSubConfirmVisible = val
  
  public setSubType = (val: string) => this.subType = val
  public setActiveTab = (val: string) => this.activeTab = val
  public setUserName = (val: string) => this.userName = val
  public setUserEmail = (val: string) => this.userEmail = val

  public async selectSubscribe() {
    this.setIsSelectSubVisible(false)
  
    await updateAccount(this.mainStore.userData.id, {
      next_sub: this.loyaltyStore.selectedNextSub
    })
  
    this.mainStore.setUserData({...this.mainStore.userData, next_sub: this.loyaltyStore.selectedNextSub})
  
    this.loyaltyStore.setIsNewSubsVisible(false)
  }

  public async uncancelSubscribe() {
    this.setIsSubUncancelVisible(false)

    const res = await uncancelSub(this.mainStore.userData.id)

    if (res.state === 1) {
      this.loyaltyStore.setIsNewSubsVisible(false)
      this.mainStore.setSubscribeData({ ...this.mainStore.subscribeData, is_end: false })

      message.success("Подписка возобновлена!")
    } else {
      message.error(res.message)
    }

    return true
  }

  public async cancelSubscribe() {
    this.setIsSubCancelVisible(false)

    const res = await cancelSub(this.mainStore.userData.id)

    if (res.state === 1) {
      this.loyaltyStore.setIsNewSubsVisible(false)
      this.mainStore.setSubscribeData({ ...this.mainStore.subscribeData, is_end: true })

      message.success("Подписка будет отменена по завершению актуального срока")
    } else {
      message.error(res.message)
    }

    return true
  }
  

}